var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.727,
    height: 18.295,
    viewBox: "0 0 12.727 18.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20268",
    "data-name": "Path 20268",
    d: "M17.439,21.095H9.088A2.088,2.088,0,0,1,7,19.007V5.088A2.088,2.088,0,0,1,9.088,3h8.351a2.088,2.088,0,0,1,2.088,2.088V19.007A2.088,2.088,0,0,1,17.439,21.095ZM9.088,4.392a.7.7,0,0,0-.7.7V19.007a.7.7,0,0,0,.7.7h8.351a.7.7,0,0,0,.7-.7V5.088a.7.7,0,0,0-.7-.7Z",
    transform: "translate(-7 -3)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20269",
    "data-name": "Path 20269",
    d: "M16.176,5.784H13.392A1.392,1.392,0,0,1,12,4.392V3.7a.7.7,0,0,1,.7-.7h4.176a.7.7,0,0,1,.7.7v.7A1.392,1.392,0,0,1,16.176,5.784ZM13.392,4.392Z",
    transform: "translate(-8.52 -3)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPhone);
export default __webpack_public_path__ + "static/media/footer-phone.9e5aba9a1bb99e1dd4028ad43fbab289.svg";
export { ForwardRef as ReactComponent };